export type IsSubjectMatchButtonDisabledParams = {
  isCrossCurrency: boolean
  isProcessing: boolean
  crossCurrencyPaymentAmount?: number
  hasMatchDifference: boolean
  selectedDifferenceType?: string | null
}

export const isSubjectMatchButtonDisabled = ({
  isCrossCurrency,
  isProcessing,
  crossCurrencyPaymentAmount,
  hasMatchDifference,
  selectedDifferenceType,
}: IsSubjectMatchButtonDisabledParams) => {
  if (isCrossCurrency) {
    return isProcessing || !crossCurrencyPaymentAmount
  }
  const hasDeviation = hasMatchDifference && !selectedDifferenceType
  return isProcessing || hasDeviation
}
